import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/recharge',
    children: [
      {
        index: true,
        element: LazyLoad(lazy(() => import('@/pages/recharge/home'))),
      },
      {
        path: 'special',
        element: LazyLoad(lazy(() => import('@/pages/recharge/special'))),
      },
    ],
  },
] as RouteObject[];
